import { render, staticRenderFns } from "./UseTerms.vue?vue&type=template&id=1c4ffd4e"
import script from "./UseTerms.vue?vue&type=script&lang=js"
export * from "./UseTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports